import { Eye } from "tabler-icons-react";

export const DegreeHeaders = [
  { id: "id", numeric: true, disablePadding: true, label: "ID" },

  //give full width to the question column
  {
    id: "degreeName",
    numeric: false,
    disablePadding: true,
    label: "Degree",
  },
  {
    id: "degreeNote",
    numeric: false,
    disablePadding: true,
    label: "Description",
  },
  {
    id: "state",
    numeric: false,
    disablePadding: true,
    label: "Status",
  },
  {
    id: "actions",
    view: <Eye />,

    numeric: false,
    label: "Actions",
  },
];
